module.exports = __webpack_public_path__ + "img/big_1_10.472e8721.png";